import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  LastUsedOfferDraftResponseSchema,
  SetLastUsedOfferDraftBodySchema,
} from '../schemas/user-preferences.js';

export const userPreferences = {
  getLastUsedOfferDraft: endpoint(
    'GET',
    '/me/preferences/last-used-offer-draft',
    z.object({}),
    LastUsedOfferDraftResponseSchema,
  ),
  setLastUsedOfferDraft: endpoint(
    'PATCH',
    '/me/preferences/last-used-offer-draft',
    SetLastUsedOfferDraftBodySchema,
    z.void(),
  ),
};
